import angular from 'angular';

/* Components */
import alertsPanelComponent from './alerts-panel/alerts-panel.component';
import assetDashboardComponent from './asset-dashboard.component';
import gaugeBuilderComponent from './components/gauge-builder/gauge-builder.component';
import statusComponent from './status/status.component';
import alarmComponent from './alarms/alarms.component';
import equipmentStatusComponent from './equipment-status/equipment-status.component';

//commands ui
import commandsView from './commands/commands.component';
import commandFeedbackHistory from './commands/feedback-history/feedback-history';
import statusCheck from './commands/status-check/status-check.component';

/* Services */
import AssetDashboardRouteConfig from './asset-dashboard.route';
import DashboardCommandsService from './commands/commands.util.service';

import layout1Component from './Layouts/layout/layout.component';
import defaultLayoutComponent from './Layouts/default/default.component';
import layoutsComponent from './Layouts/layouts.component';

const assetDashboardModule = angular
  .module('app.assetDash', ['ui.bootstrap', 'ui.router', 'gettext'])
  /* Components */
  .component('alertsPanel', alertsPanelComponent)
  .component('assetDashboard', assetDashboardComponent)
  .component('gaugeBuilder', gaugeBuilderComponent)
  .component('status', statusComponent)
  .component('alarms', alarmComponent)
  .component('commandEquipmentStatus', equipmentStatusComponent)

  .component('layout', layout1Component)
  .component('defaultLayout', defaultLayoutComponent)
  .component('layouts', layoutsComponent)

  //command ui
  .component('dCommandsView', commandsView)
  .component('dCommandsFeedbackHistory', commandFeedbackHistory)
  .component('dStatusCheck', statusCheck)

  /* Services */
  .service('dashboardCommandsService', DashboardCommandsService)
  .config(AssetDashboardRouteConfig);

export default assetDashboardModule.name;
